import React from 'react'
import type { CheckboxFieldProps } from './Checkbox.types'

export default function CheckboxField({
  name,
  checked,
  label,
  disabled,
  onChange,
}: CheckboxFieldProps) {
  return (
    <label className={`rd-checkbox${!label ? ' rd-checkbox--no-label' : ''}`}>
      <input
        className="rd-checkbox__input"
        type="checkbox"
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
      <span className="rd-checkbox__box" />
      {label && <span className="rd-checkbox__label">{label}</span>}
    </label>
  )
}
